export enum ViewTemplateType {
  Colorless = 1,
  Fancy = 2,
  Jewelry = 3,
  Rough = 4,
  Gem = 5,
}
